// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashboard-card {\n  min-height: calc(100vh - 80px);\n}\n.dashboard-card .title {\n  margin-top: 20vh;\n  text-align: center;\n  font-size: 30px;\n  font-weight: 500;\n}\n", ""]);
// Exports
module.exports = exports;
